import clsx from 'clsx'
import React from 'react'
import { FormattedMessage } from 'react-intl'

import s from './styles.module.scss'

interface IHouseSearchFilterByProps {
  activeFilterCount: number
  clearAllFilters: () => void
  showFilterSelector?: boolean
}

export const HouseSearchFilterBy = ({
  activeFilterCount,
  clearAllFilters,
  showFilterSelector,
}: IHouseSearchFilterByProps) => {
  return (
    <div
      className={clsx(s.filterWith, {
        [s.withoutHouseSearchFilterBy]: !showFilterSelector,
      })}
    >
      {activeFilterCount > 0 ? (
        <>
          <div>
            <FormattedMessage
              id='ui.HouseSearchFilterBy.selectedFilters'
              defaultMessage='{activeFilterCount, plural, one {Filtre sélectionné} other {Filtres sélectionnés}} ({activeFilterCount})'
              values={{ activeFilterCount }}
            />
          </div>
          <button onClick={clearAllFilters} className={s.clearButton}>
            <FormattedMessage
              id='ui.HouseSearchFilterBy.clearFilters'
              defaultMessage='Effacer tous les filtres'
            />
          </button>
        </>
      ) : (
        <div>
          <FormattedMessage
            id='ui.HouseSearchFilterBy.filterBy'
            defaultMessage='Filtrer par'
          />
        </div>
      )}
    </div>
  )
}
